module.exports = __webpack_public_path__ + "static/media/bg2.a9246bc9.png";